import {Component} from "react";
import {Button, Jumbotron} from "react-bootstrap";
import {Redirect} from "react-router-dom";
import {Home} from "../../config/Routes";

interface InvalidPasswordResetState{
    goHome: boolean
}
export default class InvalidPasswordReset extends Component<{}, InvalidPasswordResetState> {

    state: InvalidPasswordResetState = {
        goHome: false
    }

    render() {
        return <Jumbotron className="text-center">
                <h1>
                    Unknown Or Expired Link! Contact the site administrator if you feel this is an error.
                </h1>
                <Button onClick={() => {this.setState({goHome: true})}}>
                    Return Home
                </Button>
                {this.state.goHome && <Redirect to={Home} /> }
        </Jumbotron>
    }
}
